import { Container, Navbar } from 'react-bootstrap';
import Menu from './Menu';

function Header() {
  return (
    <Navbar id="navbar-site" bg="black" expand="lg" fixed="top">
      <Container>
        <Navbar.Brand href="/" className="d-flex align-items-center">
          <span className='cloister-black title'>Agência BlackStar</span>
        </Navbar.Brand>
        <Menu />
      </Container>
    </Navbar>
  )
}

export default Header